/**
 * Class representing frequently bought together (FBT) functionality.
 */
class fbt {
  constructor() {
    this.currentBundle = [];
  }

  /**
   * Initialize the FBT functionality.
   */
  init() {
    this.setInitialBundle();
    this.listenToRadioInputClickOnFBT();
    this.fbtAddToCart();
    this.selectVariantChange();
  }

  /**
   * Adds the current bundle to the cart.
   */
  fbtAddToCart() {
    const fbtAddToCart = document.querySelector('[js-fbt-add-to-cart]');
    if (!fbtAddToCart) {
      console.error('FBT Add to Cart button not found.');
      return;
    }
    fbtAddToCart.addEventListener('click', (event) => {
      const cartItems = this.currentBundle.map((item) => {
        return {
          id: item.selectedVariantId,
          quantity: 1,
        };
      });

      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          items: cartItems,
        }),
      })
        .then((response) => response.json())
        .then((data) => {})
        .catch((error) => {
          console.error('Error adding items to cart:', error);
        });
    });
  }

  /**
   * Listens for changes in the variant select boxes.
   */
  selectVariantChange() {
    const variantSelectBoxes = [...document.querySelectorAll('[data-fbt]')];
    if (variantSelectBoxes.length === 0) {
      console.error('No variant select boxes found.');
      return;
    }

    variantSelectBoxes.forEach((selectBox) => {
      selectBox.addEventListener('change', (event) => {
        const originalProdId = selectBox.getAttribute('data-fbt-product-id');
        if (!originalProdId) {
          console.error('Product ID not found on select box.');
          return;
        }

        const selectedVariantId = selectBox.value;
        const prodIdObj = JSON.parse(originalProdId);

        const prodIndex = this.currentBundle.findIndex((item) => {
          return item.id === prodIdObj;
        });

        if (prodIndex === -1) {
          console.error('Product not found in the current bundle.');
          return;
        }

        this.currentBundle[prodIndex].selectedVariantId = selectedVariantId;
        this.setTotalPrice();
      });
    });
  }

  /**
   * Sets the initial bundle based on selected radio inputs.
   */
  setInitialBundle() {
    const radioInputs = [
      ...document.querySelectorAll('[js-radio-button-select]'),
    ];
    if (radioInputs.length === 0) {
      console.error('No radio button inputs found.');
      return;
    }

    radioInputs.forEach((radioInput) => {
      const checkedInput = radioInput.parentNode.querySelector('input:checked');
      if (checkedInput) {
        const prodId = radioInput.getAttribute('js-radio-button-select');
        if (!prodId) {
          console.error('Product ID not found on radio input.');
          return;
        }

        const prodIdObj = JSON.parse(prodId);
        prodIdObj.selectedVariantId = prodIdObj.variants[0].id;
        this.currentBundle.push(prodIdObj);
      }
    });
    this.setTotalPrice();
  }

  /**
   * Converts a number to a fixed-point notation string.
   * @param {number} x - The number to format.
   * @return {string} - The formatted number as a string.
   */
  financial(x) {
    x = x / 100;
    return Number.parseFloat(x).toFixed(2);
  }

  /**
   * Calculates and sets the total price of the current bundle.
   */
  setTotalPrice() {
    this.currentBundle.forEach((item) => {
      const variant = item.variants.find((variant) => {
        return variant.id === parseInt(item.selectedVariantId);
      });

      if (!variant) {
        console.error('Variant not found for selected variant ID.');
        return;
      }

      item.selectedPrice = variant.price;
    });

    const totalPrice = this.currentBundle.reduce((acc, item) => {
      return acc + item.selectedPrice;
    }, 0);

    const formattedTotalPrice = `$${this.financial(totalPrice)}`;

    const totalPriceElement = document.querySelector('[js-total-price]');
    const ATCPriceSpan = document.querySelector('[js-total-price-hidden]');
    if (totalPriceElement) {
      totalPriceElement.textContent = formattedTotalPrice;
      ATCPriceSpan.innerHTML = `&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;(${formattedTotalPrice})`;
    } else {
      console.error('Total price element not found.');
    }
  }

  /**
   * Handles click events on radio inputs for FBT.
   * @param {Event} event - The event object.
   */
  handleRadioInputClickOnFBT(event) {
    const radioInput = event.target;

    event.stopPropagation();

    const prodId = radioInput.getAttribute('js-radio-button-select');
    if (!prodId) {
      console.error('Product ID not found on radio input.');
      return;
    }

    const prodIdObj = JSON.parse(prodId);

    if (radioInput.parentElement.querySelector('input:checked')) {
      this.currentBundle = this.currentBundle.filter((item) => {
        return item.id !== prodIdObj.id;
      });
      const selectBox = document.querySelector(
        `[data-fbt-product-id="${prodIdObj.id}"]`
      );

      if (selectBox) {
        selectBox.value = selectBox.options[0].value;
      }
      try {
        /* this.currentBundle empty? If so, disable the add to cart button */
        const fbtAddToCart = document.querySelector('[js-fbt-add-to-cart]');
        if (this.currentBundle.length === 0) {
          fbtAddToCart.setAttribute('disabled', 'disabled');
        } else {
          fbtAddToCart.removeAttribute('disabled');
        }
      } catch (e) {}
    } else {
      prodIdObj.selectedVariantId = prodIdObj.variants[0].id;

      const selectBox = document.querySelector(
        `[data-fbt-product-id="${prodIdObj.id}"]`
      );

      if (selectBox) {
        selectBox.value = prodIdObj.variants[0].id;
      }
      this.currentBundle.push(prodIdObj);

      /* If the add to cart button is disabled, enable it */
      try {
        const fbtAddToCart = document.querySelector('[js-fbt-add-to-cart]');
        if (fbtAddToCart.hasAttribute('disabled')) {
          fbtAddToCart.removeAttribute('disabled');
        }
      } catch (e) {}
    }

    this.setTotalPrice();
  }

  /**
   * Adds event listeners to radio inputs for FBT.
   */
  listenToRadioInputClickOnFBT() {
    const radioInputs = [
      ...document.querySelectorAll('[js-radio-button-select]'),
    ];
    if (radioInputs.length === 0) {
      console.error('No radio button inputs found.');
      return;
    }

    radioInputs.forEach((radioInput) => {
      radioInput.addEventListener('click', (event) => {
        this.handleRadioInputClickOnFBT(event);
      });
    });
  }
}



/**
 * @class Accordion
 * @description Class to handle the accordion functionality
 */
class Accordion {
  /**
   * @constructor
   * @param {string} containerSelector - The selector for the accordion container.
   */
  constructor (containerSelector) {
    this.container = document.querySelector (containerSelector);
    if (!this.container) {
      throw new Error (
        `Accordion container not found with selector: ${containerSelector}`
      );
    }
    this.triggers = this.container.querySelectorAll ('[js-accordion-trigger]');
    this.contents = this.container.querySelectorAll ('[js-accordion-content]');
    this.init ();
  }

  /**
   * @method init
   * @description Initializes the accordion by attaching event listeners to triggers.
   */
  init () {
    this.triggers.forEach (trigger => {
      trigger.addEventListener ('click', event => this.toggleAccordion (event));
    });
  }

  /**
   * @method toggleAccordion
   * @description Toggles the visibility of the accordion content associated with the clicked trigger.
   * @param {Event} event - The click event object.
   */
  toggleAccordion (event) {
    const trigger = event.currentTarget;
    const contentId = trigger.getAttribute ('js-accordion-trigger');
    const content = this.container.querySelector (
      `[js-accordion-content="${contentId}"]`
    );

    if (!content) {
      console.error (`Accordion content not found for trigger: ${contentId}`);
      return;
    }

    const isVisible = content.style.height && content.style.height !== '0px';

    // Close all contents
    this.contents.forEach (content => {
      content.style.height = '0px';
      content.previousElementSibling.querySelector (
        '[js-accordion-icon]'
      ).style.transform =
        'rotate(0deg)';
    });

    if (!isVisible) {
      // Open the clicked content
      content.style.height = `${content.scrollHeight}px`;
      trigger.querySelector ('[js-accordion-icon]').style.transform =
        'rotate(180deg)';
    }
  }
}


/**
 * YotpoCustom class for customizing Yotpo widget behavior and appearance.
 * @class
 */
class YotpoCustom {
  /**
   * Create a YotpoCustom instance.
   * @param {Object} [config={}] - Configuration options to override defaults.
   */
  constructor(config = {}) {
    // Merge default configuration with user-provided config
    this.config = {
      selectors: {
        mainWidget: '.yotpo-main-widget .avg-score',
        bottomLine: '.yotpo-bottomline.star-clickable',
        reviewsQaLabel: '.reviews-qa-label',
        bottomLineWrapper: '.bottom-line-items-wrapper',
        reviewStars: '.yotpo-review-stars',
        smallBox: '.new-yotpo-small-box',
        navPrimary: '.yotpo-nav-primary',
      },
      texts: {
        scorePrefix: "This product's score is",
        readPrefix: 'I want to read',
        reviewsPrefix: 'This product has',
        questionsPrefix: 'Users asked',
        reviewsSuffix: 'Reviews',
        questionsSuffix: 'Questions',
      },
      timeouts: {
        element: 5000,
        yotpo: 5000,
      },
      ...config,
    };

    this.config.selectors.navContent = '.yotpo-nav-content';
    this.config.selectors.nav = 'nav';

    this.init();
  }

  /*
   * When a 'nav' element is appended inside of the '.yotpo-nav-content' element, then fire the 'moveNavOutside' method.
   */
  listenForNavAppend() {
    const targetNode = document.querySelector('.yotpo-nav-content');

    if (!targetNode) {
      console.error("Target element '.yotpo-nav-content' not found");
      return;
    }
    const that = this;
    const config = { childList: true, subtree: true };

    const callback = async function (mutationsList, observer) {
      for (let mutation of mutationsList) {
        if (mutation.type === 'childList') {
          for (let node of mutation.addedNodes) {
            if (node.nodeName.toLowerCase() === 'nav') {
              if (typeof that.moveNavOutside === 'function') {
                setTimeout(async () => {
                  await that.moveNavOutside();
                }, 3000);
              } else {
                console.error('moveNavOutside function not found');
              }
              observer.disconnect(); // Stop observing once we've found the nav
              return;
            }
          }
        }
      }
    };

    const observer = new MutationObserver(callback);
    observer.observe(targetNode, config);
  }

  /**
   * Initialize the YotpoCustom instance.
   * @async
   */
  async init() {
    try {
      // Wait for the main widget to be present in the DOM
      await this.waitForElement(this.config.selectors.mainWidget);

      // Perform initial setup tasks concurrently
      await Promise.all([
        this.updateRating(),
        this.processReviews(),
        this.waitForSmallBoxElement(),
        // this.moveNavOutside(), // Add this line to call the new method
      ]);

      // Wait for Yotpo to be available and initialize it
      await this.waitForYotpo();
      // this.listenForNavAppend();
      this.initYotpo();
      this.listenToYotpoEvents();
    } catch (error) {
      console.error('Initialization failed:', error);
    }
  }

  /**
   * Move the nav element outside of its parent in the .yotpo-nav-content
   * @async
   */
  async moveNavOutside() {
    const navContentElement = await this.waitForElement(
      this.config.selectors.navContent
    );

    try {
      // Wait for the .yotpo-nav-content element to exist
      const navContentElement = await this.waitForElement(
        this.config.selectors.navContent
      );

      if (navContentElement.length === 0) {
        console.error('No .yotpo-nav-content element found');
        return;
      }

      // Find the nav element within .yotpo-nav-content
      const navElement = navContentElement[0].querySelector(
        this.config.selectors.nav
      );

      if (!navElement) {
        console.error('No nav element found within .yotpo-nav-content');
        return;
      }

      // Get the parent of .yotpo-nav-content
      const parentElement = navContentElement[0].parentElement;

      if (!parentElement) {
        console.error('No parent element found for .yotpo-nav-content');
        return;
      }

      // Move the nav element outside of its current parent
      parentElement.insertBefore(navElement, navContentElement[0].nextSibling);
    } catch (error) {
      console.error('Error in moveNavOutside:', error);
    }
  }

  /**
   * Update the rating display in the main widget.
   * @async
   */
  async updateRating() {
    const avgScoreElements = await this.waitForElement(
      this.config.selectors.mainWidget
    );

    const origText = avgScoreElements[0].innerText || '';

    // Update each score element found
    avgScoreElements.forEach((el) => this.updateScoreElement(el, origText));
  }

  /**
   * Update a single score element with the new format.
   * @param {HTMLElement} element - The element to update.
   * @param {string} score - The original score text.
   */
  updateScoreElement(element, score) {
    // Set the new score format
    element.innerText = `${score} / 5`;

    // Create and insert the prefix span
    const span = document.createElement('span');
    span.innerText = this.config.texts.scorePrefix;
    element.parentNode.insertBefore(span, element);
  }

  /**
   * Initialize Yotpo-specific functionality.
   * @async
   */
  async initYotpo() {
    const starClickableElements = await this.waitForElement(
      this.config.selectors.bottomLine
    );
    // Extract review text, removing 'REVIEWS' suffix
    const reviewText =
      starClickableElements[0]
        ?.querySelector('a')
        ?.innerText.replace('REVIEWS', '') || '';
  }

  /**
   * Process reviews and questions data.
   * @async
   */
  async processReviews() {
    const reviewsQaLabel = await this.waitForElement(
      this.config.selectors.reviewsQaLabel
    );
    if (!reviewsQaLabel[0]) return;

    // Extract review and question counts
    const [reviews, questions] = reviewsQaLabel[0].innerText.split(',');
    let numQuestions;
    const numReviews = this.extractNumber(reviews);
    if (questions) {
      numQuestions = this.extractNumber(questions);
    }

    const bottomLineWrappers = await this.waitForElement(
      this.config.selectors.bottomLineWrapper
    );
    bottomLineWrappers.forEach((wrapper) => {
      // Create info elements for reviews and questions
      this.createInfoElement(
        wrapper,
        'reviews',
        numReviews,
        this.config.texts.reviewsPrefix,
        this.config.texts.reviewsSuffix
      );
      this.createInfoElement(
        wrapper,
        'questions',
        numQuestions,
        this.config.texts.questionsPrefix,
        this.config.texts.questionsSuffix
      );
    });

    // Reposition review stars
    await this.moveReviewStars();
    await this.moveAggregatedUserFields();
  }

  listenToYotpoEvents() {
    setTimeout(() => {
      document
        .querySelectorAll(
          '.product-app--container .yotpo-main-widget .yotpo-active:not(.yotpo-reviews-filters) nav a'
        )
        .forEach((el) => {
          el.addEventListener('click', () => {
            setTimeout(() => {
              const aggregatedUserFields = document.querySelectorAll(
                '.aggregated-product-related-fields'
              );
              aggregatedUserFields.forEach((el) => {
                /* move each aggregated user field to be a sibling of the closest '.yotpo-review-wrapper' */
                const waitingForClosestReviewMain = setInterval(() => {
                  const closestReviewMain = el.closest('.yotpo-main');
                  if (closestReviewMain) {
                    clearInterval(waitingForClosestReviewMain);
                    const closestReviewWrapper =
                      closestReviewMain.querySelector('.yotpo-review-wrapper');

                    if (closestReviewWrapper) {
                      closestReviewWrapper.appendChild(el);
                    }
                  }
                }, 100);
              });
            }, 1000);
          });
        });
    }, 2000);
  }

  async moveAggregatedUserFields() {
    const aggregatedUserFields = await this.waitForElement(
      '.aggregated-product-related-fields'
    );
    aggregatedUserFields.forEach((el) => {
      /* move each aggregated user field to be a sibling of the closest '.yotpo-review-wrapper' */
      const waitingForClosestReviewMain = setInterval(() => {
        const closestReviewMain = el.closest('.yotpo-main');
        if (closestReviewMain) {
          clearInterval(waitingForClosestReviewMain);
          const closestReviewWrapper = closestReviewMain.querySelector(
            '.yotpo-review-wrapper'
          );

          if (closestReviewWrapper) {
            closestReviewWrapper.appendChild(el);
          }
        }
      }, 100);
    });
  }

  /**
   * Extract numeric value from a string.
   * @param {string} text - The text to extract number from.
   * @returns {string} The extracted number as a string.
   */
  extractNumber(text) {
    return text.replace(/\D/g, '').trim();
  }

  /**
   * Create and append an info element to the wrapper.
   * @param {HTMLElement} wrapper - The wrapper element to append to.
   * @param {string} className - The class name for the new element.
   * @param {string|number} count - The count to display.
   * @param {string} prefix - The text to prefix the count.
   * @param {string} suffix - The text to suffix the count.
   */
  createInfoElement(wrapper, className, count, prefix, suffix) {
    if (!count) return;
    const element = document.createElement('div');
    element.innerHTML = `
      <span>${prefix}</span>
      <span class="avg-score font-color-gray-darker">${count}</span>
      <span class="last-span">${suffix}</span>
    `;
    element.classList.add(
      'bottom-line-items',
      `bottom-line-items--${className}`
    );
    wrapper.appendChild(element);
  }

  /**
   * Move review stars to the end of their parent elements.
   * @async
   */
  async moveReviewStars() {
    const reviewStars = await this.waitForElement(
      this.config.selectors.reviewStars
    );
    reviewStars.forEach((el) => {
      const parent = el.closest('.yotpo-header');
      if (parent) {
        parent.appendChild(el);
      }
    });
  }

  /**
   * Wait for small box element and add custom header.
   * @async
   */
  async waitForSmallBoxElement() {
    await this.waitForElement(this.config.selectors.smallBox);
    const h4 = document.createElement('h4');
    h4.innerText = this.config.texts.readPrefix;
    h4.classList.add('h4--36');

    const navElements = await this.waitForElement(
      this.config.selectors.navPrimary
    );
    navElements.forEach((el) => {
      el.insertBefore(h4.cloneNode(true), el.firstChild);
    });
  }

  /**
   * Wait for an element to appear in the DOM.
   * @param {string} selector - The CSS selector for the element.
   * @returns {Promise<NodeList>} A promise that resolves with the matched elements.
   */
  waitForElement(selector) {
    return new Promise((resolve, reject) => {
      const observer = new MutationObserver((mutations, obs) => {
        const elements = document.querySelectorAll(selector);
        if (elements.length > 0) {
          obs.disconnect();
          resolve([...elements]);
        }
      });

      observer.observe(document.body, {
        childList: true,
        subtree: true,
      });

      // Reject the promise if the element doesn't appear within the timeout
      setTimeout(() => {
        observer.disconnect();
        reject(new Error(`Timeout waiting for ${selector}`));
      }, this.config.timeouts.element);
    });
  }

  /**
   * Wait for Yotpo to be available on the window object.
   * @returns {Promise<Object>} A promise that resolves with the Yotpo object.
   */
  waitForYotpo() {
    return new Promise((resolve, reject) => {
      if (window.yotpo) {
        resolve(window.yotpo);
      } else {
        const observer = new MutationObserver(() => {
          if (window.yotpo) {
            observer.disconnect();
            resolve(window.yotpo);
          }
        });

        observer.observe(document.body, {
          childList: true,
          subtree: true,
        });

        // Reject the promise if Yotpo doesn't appear within the timeout
        setTimeout(() => {
          observer.disconnect();
          reject(new Error('Timeout waiting for window.yotpo'));
        }, this.config.timeouts.yotpo);
      }
    });
  }
}



/**
 * Product Class
 *
 * This class initializes product variants and sets up event listeners
 * for variant input changes.
 */
class Product {
  /**
   * Constructor for Product class
   * Initializes the class by calling the init method.
   */
  constructor(config) {
    /* check if config is an object and not empty */
    let isQuickView = false;
    if (config && Object.keys(config).length) {
      isQuickView = config.isQuickView;
    }

    this.isQuickView = isQuickView;

    try {
      this.init();
      if (!isQuickView) {
        const fbtInstance = new fbt();
        fbtInstance.init();
        const myAccordion = new Accordion('.faq-accordion');

        const yotpoInstance = new YotpoCustom();
      }
    } catch (error) {
      console.error('Error during class initialization:', error);
    }
  }

  /**
   * Initializes the Product class.
   * Sets up the variant method and logs initialization.
   */
  init() {
    try {
      this.variant();
      this.checkForRechargeWidget();
      if (!this.isQuickView) {
        this.getRecentlyViewedProducts();
      }
    } catch (error) {
      console.error('Initialization error:', error);
    }
  }

  getRecentlyViewedProducts() {
    const interval = setInterval(() => {
      const recentlyViewed = window.RecentlyViewedWidget;
      if (recentlyViewed) {
        clearInterval(interval);
        recentlyViewed.View.carousel.element.classList.add('recently-viewed');
      }
    }, 100);
  }

  moveSubscriptionDropdown() {
    /** 
     * Convert this to a set interval to wait for the element to exist, and then move it and clear the interval.
    setTimeout (() => {
      const dropdownToBeMoved = document.querySelector (
        '[data-plans-container]'
      );

      const elementToMoveAfter = document.querySelector ('.rc_popup');

      if (dropdownToBeMoved && elementToMoveAfter) {
        elementToMoveAfter.parentNode.insertBefore (
          dropdownToBeMoved,
          elementToMoveAfter.nextSibling
        );
        dropdownToBeMoved.classList.add ('!flex');
      }

      const radioInputs = document.querySelectorAll ('.rc-radio__input');
      radioInputs.forEach (radioInput => {
        const customRadio = document.createElement ('div');
        customRadio.classList.add ('custom-radio');
        radioInput.parentNode.insertBefore (
          customRadio,
          radioInput.nextSibling
        );
      });
    }, 2000);
    */

    const interval = setInterval(() => {
      const dropdownToBeMoved = document.querySelector(
        '[data-plans-container]'
      );

      const elementToMoveAfter = document.querySelector('.rc_popup');

      if (dropdownToBeMoved && elementToMoveAfter) {
        clearInterval(interval);
        elementToMoveAfter.parentNode.insertBefore(
          dropdownToBeMoved,
          elementToMoveAfter.nextSibling
        );
        dropdownToBeMoved.classList.add('!flex');
        const radioInputs = document.querySelectorAll('.rc-radio__input');

        radioInputs.forEach((radioInput) => {
          try {
            const customRadio = document.createElement('div');
            customRadio.classList.add('custom-radio');
            radioInput.parentNode.insertBefore(
              customRadio,
              radioInput.nextSibling
            );
            /* get event listeners for each radio input */
            customRadio.addEventListener('click', (e) => {
              e.currentTarget.previousElementSibling.click();
            });
          } catch (e) {
            console.error('Error in getting event listeners:', e);
          }
        });
      }
    }, 100);
  }

  wholeElementClickListeners() {
    const interval = setInterval(() => {
      const radioInputs = document.querySelectorAll('.rc-radio');

      if (radioInputs.length > 0) {
        clearInterval(interval);
        radioInputs.forEach((radioInput) => {
          radioInput.addEventListener('click', (e) => {
            const radioElement = e.target.querySelector('.custom-radio');
            if (radioElement) {
              radioElement.click();
            }
          });
        });
      }
    }, 100);
  }

  wholeElementTextBlockClickListeners() {
    const interval = setInterval(() => {
      const textBlocks = document.querySelectorAll('.subscription-label-text');

      if (textBlocks.length > 0) {
        clearInterval(interval);
        textBlocks.forEach((textBlock) => {
          textBlock.addEventListener('click', (e) => {
            const radioElement = textBlock
              .closest('.rc-radio')
              .querySelector('.custom-radio');
            if (radioElement) {
              radioElement.click();
            }
          });
        });
      }
    }, 100);
  }

  waitForRechargeWidgetAndThenAddLabel() {
    /* element to wait for .rc-template */
    const interval = setInterval(() => {
      const rechargeWidget = document.querySelector('.rc-template');
      if (rechargeWidget) {
        const subscriptionLabel = document.createElement('label');
        subscriptionLabel.classList.add(
          'option-title',
          'w-full',
          'flex-[1_1_100%]'
        );
        subscriptionLabel.textContent = 'Purchase options';
        /* add subscriptionLabel before the rechargeWidget */
        rechargeWidget.parentNode.insertBefore(
          subscriptionLabel,
          rechargeWidget
        );
        clearInterval(interval);
      }
    }, 100);
  }

  listenForPriceChangeAndThenGetOriginalPrice() {
    
    /* mutation observer to listen for price changes */
    const priceElement = document.querySelector('[data-price-subsave]');
    let price;
    let originalPrice;
    const observer = new MutationObserver((mutations) => {
      observer.disconnect(); // Temporarily stop observing

      mutations.forEach((mutation) => {
        if (this.isQuickView) {           
          window.ReChargeWidget.getWidgets().forEach((widget) => {
            const { original, discounted } = widget.variants.getVariantPrices(
              widget.state.selectedVariantId,
              widget.store.getters.selectedProductPlan.id
            );

            if (document.body.dataset.cartcurrency != "USD") {
              debugger
              let thiswidget = window.ReChargeWidget.getWidgets().find(s=>s.productId == window.productData.id);
              const { regularPrice, subscriptionPrice } = this.updateProductPricesQV(parseInt(thiswidget.state.selectedVariantId));
              discounted = subscriptionPrice;
              original = regularPrice;
            }

            debugger
            // price = discounted;
            price = new Intl.NumberFormat('en-US', {
              style: 'currency',
              currency: document.body.dataset.cartcurrency, //'USD',
            }).format(discounted);
            originalPrice = new Intl.NumberFormat('en-US', {
              style: 'currency',
              currency: document.body.dataset.cartcurrency, //'USD',
            }).format(original);
          });
        }
        const originalPriceElement = document.querySelector(
          '[data-price-onetime]'
        );
        if (originalPriceElement) {
          /* Add the original price within the priceElement before the original text, in a new span element */
          if (this.isQuickView) {
            const originalPriceSpan = document.createElement('span');
            originalPriceSpan.classList.add('compare-at-price');
            originalPriceSpan.textContent = originalPrice;
            priceElement.innerHTML = `${originalPriceSpan.outerHTML} ${price}`;
            originalPriceElement.textContent = originalPrice;
          } else {
            const originalPrice = originalPriceElement.textContent;
            const originalPriceSpan = document.createElement('span');
            originalPriceSpan.classList.add('compare-at-price');
            originalPriceSpan.textContent = originalPrice;
            priceElement.innerHTML = `${originalPriceSpan.outerHTML} ${priceElement.textContent}`;
          }
        }
      });

      observer.observe(priceElement, {
        // Restart observing
        childList: true,
        subtree: true,
      });
    });

    observer.observe(priceElement, {
      childList: true,
      subtree: true,
    });
  }

  waitForPriceThenGetOriginalPrice() {
    
    // if (this.isQuickView) return; // sanket
    
    const interval = setInterval(() => {
      const priceElement = document.querySelector('[data-price-subsave]');
      let price;
      if (this.isQuickView) {
        window.ReChargeWidget.getWidgets().forEach((widget) => {
          const { original, discounted } = widget.variants.getVariantPrices(
            widget.state.selectedVariantId,
            widget.store.getters.selectedProductPlan.id
          );

           if (document.body.dataset.cartcurrency != "USD") {
              debugger
              const { regularPrice, subscriptionPrice } = this.updateProductPricesQV(parseInt(widget.state.selectedVariantId));
              discounted = subscriptionPrice;
              original = regularPrice;
            }
          
          // price = discounted;
          price = new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: document.body.dataset.cartcurrency, //'USD',
          }).format(discounted);
        });
      }
      if (priceElement) {
        if (!this.isQuickView) {
          price = priceElement.textContent;
        }
        const originalPriceElement = document.querySelector(
          '[data-price-onetime]'
        );
        if (originalPriceElement) {
          /* Add the original price within the priceElement before the original text, in a new span element */
          const originalPrice = originalPriceElement.textContent;
          const originalPriceSpan = document.createElement('span');
          originalPriceSpan.classList.add('compare-at-price');
          originalPriceSpan.textContent = originalPrice;
          priceElement.innerHTML = `${originalPriceSpan.outerHTML} ${price}`;
          this.listenForPriceChangeAndThenGetOriginalPrice();
        }
        clearInterval(interval);
      }
    }, 100);
  }

  addTextToSubscriptionLabel() {
    /* set interval to wait for existance of element with attribute data-option-subsave */
    const interval = setInterval(() => {
      const subscriptionLabel = document.querySelector('[data-option-subsave]');
      if (subscriptionLabel) {
        const textArray = [
          'Pause, swap or cancel when you want',
          'Accurate and regular delivery',
          'Free shipping on orders over $39',
        ];
        const svgIcon = `<svg class="mr-[10px]" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="2" y="2" width="16" height="16" rx="8" fill="#00BB99"/>
        <path d="M5.99914 9.97938L8.91247 12.8724L14 7.80518" stroke="white" stroke-width="2"/>
        </svg>
        `;
        /* create a div element to hold the list of text */
        const textContainer = document.createElement('div');
        textContainer.classList.add('subscription-label-text');
        /* for each text in the array, create a div element and append it to the textContainer */
        textArray.forEach((text) => {
          const textElement = document.createElement('div');
          /* add two classes to the textElement */
          textElement.classList.add(
            'subscription-label-text-item',
            'flex',
            'items-center',
            'mb-[4px]'
          );
          textElement.innerHTML = `${svgIcon} <span class="rc-list-text">${text}</span>`;
          textContainer.appendChild(textElement);
        });
        /* append the textContainer to the subscriptionLabel */
        subscriptionLabel.appendChild(textContainer);

        clearInterval(interval);
      }
    }, 100);
  }

  inputListeners() {
    // if (this.isQuickView) return;
    setTimeout(() => {
      [...document.querySelectorAll('.rc_widget__option__input')].forEach(
        (radioInput) => {
          radioInput.addEventListener('change', (event) => {
            this.setATCPriceLabel();
          });
        }
      );


      // SWATCHES
      [...document.querySelectorAll('div.sa-option[data-variant-id]')].forEach(
        (radioInput) => {
          radioInput.addEventListener('change', (event) => {
            this.setATCPriceLabel();
          });
        }
      );

      /* The same for [data-plans-dropdown] select element */
      const selectElement = document.querySelector('[data-plans-dropdown]');
      if (selectElement) {
        selectElement.addEventListener('change', (event) => {
          this.setATCPriceLabel();
        });
      }
    }, 3000);



    this.waitForElements(
        [
          '.rc_widget__option__input',
          'div.sa-option[data-variant-id]',
          '[data-plans-dropdown]'
        ],
        () => {
          // -- RADIO BUTTONS --
          document.querySelectorAll('.rc_widget__option__input')
            .forEach(radioInput => {
              radioInput.addEventListener('change', () => {
                this.setATCPriceLabel();
              });
            });

          // -- SWATCHES --
          document.querySelectorAll('div.sa-option[data-variant-id]')
            .forEach(option => {
              option.addEventListener('change', () => {
                this.setATCPriceLabel();
              });
            });

          // -- SELECT --
          const selectElement = document.querySelector('[data-plans-dropdown]');
          if (selectElement) {
            selectElement.addEventListener('change', () => {
              this.setATCPriceLabel();
            });
          }
        }
      );
      
  }
  

  waitForElements(selectors, callback, timeout = 10000) {
      const intervalVal = 200;
      const endTime = Date.now() + timeout;

      function check() {
        const elements = selectors
          .map(sel => [...document.querySelectorAll(sel)])
          .flat()
          .filter(el => el);

        if (elements.length > 0) {
          callback(elements);
        } else if (Date.now() < endTime) {
          setTimeout(check, intervalVal);
        }
      }

      check();
  }

  checkForRechargeWidget() {
    try {
      if (this.isQuickView) {
        try {
          this.waitForRechargeWidgetAndThenAddLabel();
          this.addTextToSubscriptionLabel();
          this.moveSubscriptionDropdown();
          this.waitForPriceThenGetOriginalPrice();

          this.inputListeners();
          this.wholeElementClickListeners();
          this.wholeElementTextBlockClickListeners();
        } catch (err) {
          console.error('Error in checkForRechargeWidget:', err);
        }
      } else {
        window.addEventListener('ReChargeWidget-loaded', () => {
          this.waitForRechargeWidgetAndThenAddLabel();
          this.addTextToSubscriptionLabel();

          this.moveSubscriptionDropdown();

          this.waitForPriceThenGetOriginalPrice();

          this.inputListeners();
          this.wholeElementClickListeners();
          this.wholeElementTextBlockClickListeners();
        });
      }
    } catch (e) {
      console.error('Error in checkForRechargeWidget:', e);
    }
  }
  
  updateProductPricesQV(selectedVariantId) {
    
    let productJson = window.productData;
    
    // Find the selected variant
    const selectedVariant = productJson.variants.find(
      variant => variant.id === selectedVariantId
    );
  
    if (!selectedVariant) {
      console.error('Selected variant not found');
      return { regularPrice: null, subscriptionPrice: null };
    }
  
    // Get prices
    const regularPrice = this.formatPrice(selectedVariant.price);
    
    // Get subscription price from selling plan allocations
    const subscriptionPrice = selectedVariant.selling_plan_allocations && 
      selectedVariant.selling_plan_allocations.length > 0 
      ? this.formatPrice(selectedVariant.selling_plan_allocations[0].price)
      : this.formatPrice(selectedVariant.price); // Fallback to regular price if no subscription price
  
    // Return both prices
    return { regularPrice, subscriptionPrice };
  }
  
  // Helper function to format price
  formatPrice(price) {
    if (!price) return '';
    return (price / 100).toFixed(2);
  }
  applyOneTimeAmtOnSwatches() {
    const swatches = document.querySelectorAll("[data-variant-id]");
  
    swatches.forEach((swatch) => {
      const variantId = parseInt(swatch.getAttribute("data-variant-id"));
      const variant = window.productData.variants.find(v => v.id === variantId);
  
      if (!variant) return;
  
      let price = variant.price / 100;
  
      if (document.body.dataset.cartcurrency !== "USD") {
        // Optional: handle currency conversion if needed for non-USD
        const { regularPrice } = this.updateProductPricesQV(variantId);
        price = regularPrice;
      }
  
      const priceFormatted = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: document.body.dataset.cartcurrency,
      }).format(price);
  
      const priceElement = swatch.querySelector(".sa-price");
      if (priceElement) {
        priceElement.textContent = priceFormatted;
      }
    });
  }
  
  applySubsriptionsAmtOnSwatches() {
      const swatches = document.querySelectorAll("[data-variant-id]");
      const widgets = window.ReChargeWidget.getWidgets();
      const widget = widgets.find(w => w.productId == window.productData.id);
    
      if (!widget) return;
    
      swatches.forEach((swatch) => {
        const variantId = parseInt(swatch.getAttribute("data-variant-id"));
        let price = null;
    
        if (document.body.dataset.cartcurrency !== "USD") {
          const { subscriptionPrice } = this.updateProductPricesQV(variantId);
          price = subscriptionPrice;
        } else {
          const selectedPlan = widget.store.getters.selectedProductPlan;
          const prices = widget.variants.getVariantPrices(variantId, selectedPlan?.id);
          price = prices?.discounted ?? prices?.original;

          const { subscriptionPrice } = this.updateProductPricesQV(variantId);
          price = subscriptionPrice;
          
        }
    
        if (price !== null) {
          const priceFormatted = new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: document.body.dataset.cartcurrency,
          }).format(price);
    
          const priceElement = swatch.querySelector(".sa-price");
          if (priceElement) {
            priceElement.textContent = priceFormatted;
          }
        }
      });
  }
  
  setATCPriceLabel() {
    //if (this.isQuickView) return; // sanket

    var subdivcontainer = document.querySelector(".main-product .rc-container-wrapper.rc_container_wrapper");
    if(subdivcontainer != null && document.querySelector('.rc_widget__option__input:checked') != null){
      subdivcontainer.setAttribute("subtype",document.querySelector('.rc_widget__option__input:checked').value);
    }
    
    const widgets = window.ReChargeWidget.getWidgets().map((widget) => {
      return widget;
    });

    const isSubscription = widgets[0].emitters.subscriptionActive;
    debugger
    if(isSubscription != true){
      
        if(this.variantId == null)
            this.variantId = document.querySelector(".shopify-product-form [name='id']").value;

        const selVariant = window.productData.variants.find(s=>s.id == this.variantId)
        
        const priceToShow = selVariant.price/100;
        const priceFormatted = new Intl.NumberFormat('en-US', {
          style: 'currency',
          currency: document.body.dataset.cartcurrency, //'USD',
        }).format(priceToShow);
    
        const priceElement = document.querySelector('[data-atc-price]');
        if (priceElement) {
          priceElement.innerHTML = `&nbsp; &nbsp;(${priceFormatted})`;
        }
      
    }else{
        const prices = widgets[0].variants.getVariantPrices(
          widgets[0].state.selectedVariantId,
          widgets[0].store.getters.selectedProductPlan.id
        );
         
        //if (document.body.dataset.cartcurrency != "USD" && (this.isQuickView)) {
                  
                  let thiswidget = widgets.find(s=>s.productId == window.productData.id);
                  const { regularPrice, subscriptionPrice } = this.updateProductPricesQV(parseInt(thiswidget.state.selectedVariantId));
                  prices.discounted = subscriptionPrice;
                  prices.original = regularPrice;
        //}
        
        const priceToShow = isSubscription ? prices.discounted : prices.original;
        const priceFormatted = new Intl.NumberFormat('en-US', {
          style: 'currency',
          currency: document.body.dataset.cartcurrency, //'USD',
        }).format(priceToShow);
    
        const priceElement = document.querySelector('[data-atc-price]');
        if (priceElement) {
          priceElement.innerHTML = `&nbsp; &nbsp;(${priceFormatted})`;
        }  
    }

    
    if (isSubscription != true) {
      this.applyOneTimeAmtOnSwatches();
    } else {
      this.applySubsriptionsAmtOnSwatches();
    }
    
    
  }

  /**
   * Sets up event listeners for variant input changes.
   * Updates the data-variants element value based on the selected variant input.
   */
  variant() {
    try {
      // Query all elements with data-js-variant-input attribute
      const inputs = document.querySelectorAll('[data-js-variant-input]');
      if (!inputs.length) {
        console.warn('No variant inputs found');
        return;
      }

      // Cache the data-variants element
      const variantElement = document.querySelector('[data-variants]');
      if (!variantElement) {
        console.warn('No data-variants element found');
        return;
      }

      // Iterate over each input and set up event listeners
      inputs.forEach((input) => {
        // Type checking for input element
        if (!(input instanceof HTMLElement)) {
          console.warn('Invalid input element:', input);
          return;
        }

        // Add change event listener to each input element
        input.addEventListener('change', (event) => {
          const target = event.target;

          // Type checking for event target element
          if (!(target instanceof HTMLElement)) {
            console.error('Event target is not an HTML element');
            return;
          }

          // Get the variant-id attribute from the target element
          const variantId = target.getAttribute('variant-id');
          this.variantId = variantId; 
          if (!variantId) {
            console.error('No variant-id attribute found on target element');
            return;
          }

          // Set the value of the variantElement to the selected variantId
          variantElement.value = variantId;
          variantElement.checked = true;
          variantElement.setAttribute('checked', 'checked');
          variantElement.click();
          variantElement.dispatchEvent(new Event('change'));
          /* Find which '.rc-radio__input' in the DOM is checked and then click it */
          const checkedRadioInput = document.querySelector(
            '.rc-radio__input:checked'
          );
          if(checkedRadioInput != null){
            checkedRadioInput.click();
            checkedRadioInput.dispatchEvent(new Event('click'));
          }
          
          this.setATCPriceLabel();
        });
      });
    } catch (error) {
      console.error('Variant method error:', error);
    }
  }
}

// Add event listener for DOMContentLoaded to initialize the Product class

document.addEventListener('DOMContentLoaded', () => {
  const containsProductsAndCollections = window.location.pathname.includes(
    'products' && 'collections'
  );
  const containsOnlyCollectionsAndNotProducts =
    window.location.pathname.includes('collections' && !'products');

  try {
    if (
      window.location.pathname.includes('products') &&
      !containsOnlyCollectionsAndNotProducts
    ) {
      const product = new Product();
    }
    // new Product();
  } catch (error) {
    console.error('Error during DOMContentLoaded event:', error);
  }
});

